"use client"

import { useEffect } from "react"

/**
 * JS Tasks that should be performed after page is initially loaded
 */
export function InitialSetup() {
  useEffect(() => {
    // Add smooth scrolling to page, after page has been loaded - prevents the page from smooth scrolling on page load - looks weird and creates bugs
    const node = document.createElement("style")
    node.innerHTML = "html {scroll-behavior: smooth;}"
    document.head.appendChild(node)
  }, [])

  return null
}
